import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { assetImagePath } from 'interfaces/constants'

export const StyledStepCardInfo = styled.div`
  position: relative;
  border-radius: ${theme.borderRadius};
  background-color: ${theme.colors.white};
  filter: drop-shadow(0px 16px 24px rgba(0, 0, 0, 0.06))
    drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.04))
    drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));
`
export const StyledStepCardTitle = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  background-image: url('${assetImagePath}/step.png');
  background-repeat: no-repeat;
  ${MediaQueries.mbUp} {
    width: 160px;
    height: 50px;
    margin-top: 24px;
    left: -18px;
    background-size: 160px 50px;
    .text {
      margin-top: 4px;
      text-transform: uppercase;
    }
  }
  ${MediaQueries.mbDown} {
    width: 120px;
    height: 32px;
    margin-top: 16px;
    left: -14px;
    background-size: 120px 32px;
  }
`
export const StyledStepCardDescription = styled.div`
  padding: 24px;
  li + li {
    margin-bottom: 8px;
  }
  ${MediaQueries.mbUp} {
    line-height: 1.5;
    font-size: 18px;
  }
  ${MediaQueries.mbDown} {
    line-height: 1.3;
    font-size: 16px;
    margin-bottom: 16px;
  }
`

export const StyledStepCardIcon = styled.div`
  width: 120px;
  height: 120px;
  margin: auto;

  ${MediaQueries.mbUp} {
    margin-top: 88px;
  }

  ${MediaQueries.mbDown} {
    margin-top: 72px;
  }
`
